import { AcceleratorBatch } from "./AcceleratorBatch";
import AcceleratorDoc from "./AcceleratorDoc";
import { AcceleratorDocMetadata } from "./AcceleratorDocMetadata";
import { BatchClassConfig } from "./config/BatchClassConfig";

export { sortBatches, sortDocs, sortBatchClasses };

/**
 * sort batches reverse chronologically by `AcceleratorBatch.created`
 * @param batches batches to sort
 */
function sortBatches(batches: AcceleratorBatch[]) {
  batches.sort((a, b) => (b.created ?? 0) - (a.created ?? 0));
}
/**
 * sort docs by `AcceleratorDocStoreKey.docId`
 * @param docs
 */
function sortDocs(docs: Array<AcceleratorDoc | AcceleratorDocMetadata>) {
  docs.sort(
    (a, b) =>
      parseInt(a.storeId.docId.replace("DOC", "")) -
      parseInt(b.storeId.docId.replace("DOC", "")),
  );
}
/**
 * sort batch class configs chronologically by creation date
 * @param bcc batch class configs to sort
 */
function sortBatchClasses(bcc: BatchClassConfig[]) {
  bcc.sort((a, b) => (a.created ?? -1) - (b.created ?? -1));
}

class SweetListSorter {
  static sort<T>(
    object: Array<T>,
    arrayKeyAccessor: (data: T) => string,
    prefix?: string,
    base: number = 16,
  ): boolean {
    // get properties / modified array from object Array
    const keyArray = object.map(arrayKeyAccessor);
    if (!keyArray.every((i) => typeof i === "string")) {
      return false;
    }
    // sort keyArray
    this.sortKeyArray(prefix, keyArray, base);
    // now sort array by arrayKeyAccesor return value as an index of KeyArray
    object.sort((a: any, b: any) => {
      const key_a: string = arrayKeyAccessor(a);
      const key_b: string = arrayKeyAccessor(b);
      return keyArray.indexOf(key_a) - keyArray.indexOf(key_b);
    });
    return true;
  }

  private static sortKeyArray(
    prefix: string | undefined,
    keyArray: string[],
    base: number,
  ) {
    keyArray.sort((str_a: string, str_b: string) => {
      let tmp_str_a = str_a;
      let tmp_str_b = str_b;
      // remove prefix from each value in array
      if (prefix != null) {
        if (tmp_str_a.startsWith(prefix))
          tmp_str_a = tmp_str_a.substr(prefix.length);
        if (tmp_str_b.startsWith(prefix))
          tmp_str_b = tmp_str_b.substr(prefix.length);
      }
      // convert to base 16
      const n_a = parseInt(tmp_str_a, base);
      const n_b = parseInt(tmp_str_b, base);
      // NaN check
      if (isNaN(n_a) || isNaN(n_b)) return 1;
      return n_a - n_b;
    });
  }
}
export default SweetListSorter;
